import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-musiclessons',
  templateUrl: './musiclessons.component.html',
  styleUrls: ['./musiclessons.component.less']
})
export class MusiclessonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
